import { orderBy } from 'lodash'
import { getCommonWidget } from '../dashWidgetHelper'
import { commonWidgets, OXXO_COLORS_STACKED_BAR, OXXO_DEFAULT_COLORS, OXXO_DEFAULT_SCALE_3_COLORS } from './commonWidgetsOxxo'
import { getLineDetailedRadar } from '../widgetsLibrary/widgetsLine'
import { getSelectedGeos } from '@utils/GeoUtils'


const orderMapper = (data: any) => {
    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
        ...item,
    }))
}

export default {
    title: 'Bañios Dashboard',
    description: 'Dashboard de perfil baños',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        //console.log('TEST DASHBORD RENDER!!!!')
        const selGeos = getSelectedGeos(filtersData?.geographicDistributions, filters?.geographicDistributions)

        let level = undefined
        if (selGeos.length === 1) {
            if ([3, 6, 9].includes(selGeos[0]?.searchCodeFrom?.length)) {
                level = 4
            } else if (selGeos[0]?.searchCodeFrom?.length === 12) {
                level = 5
            }
        }

        //console.log(selGeos)
        //console.log(`manda level ${level}`)

        const geoGrupedCondition = level !== undefined
            ? { default: { group: 'formattedMonth,geoLocation', level: level } }
            : undefined

        return [
            {
                title: 'Satisfacción - Limpieza',
                type: 'label',
                size: [4, 1],
                config: { color: '#B7AADC' },
            },
            getLineDetailedRadar({
                mainIndicator: 'OXXO_BANIO_LIMPIEZA',
                mainIndicatorGral: 'satisfaction',
                radialIndicators: [],
                size: [4, 4],
                title: 'Satisfacción General',
                extraConfigs: {
                    backgroundColor: 'transparent',
                    theme: 'dark',
                    showRadialChart: false,
                    colors: [OXXO_DEFAULT_COLORS.VERDE, OXXO_DEFAULT_COLORS.AMARILLO, OXXO_DEFAULT_COLORS.ROJO, OXXO_DEFAULT_COLORS.AZUL],
                    decimals: 1,
                    symbol: ''
                },
                criticalMomentInclude: [12951],
                indicatorsNames: { 'OXXO_BANIO_LIMPIEZA': 'Satisfacción' },
                geoGrupedCondition: geoGrupedCondition
            }),
            /*{
                title: 'Atributos en la experiencia de Grado de SATISFACION',
                type: 'label',
                size: [4, 1],
                config: { color: '#B7AADC' },
            },*/
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Satisfacción sobre la limpieza del baño',
                helpText: '¿Cómo calificarías la limpieza general de los sanitarios?',
                size: [2, 2],
                indicator: 'OXXO_BANIO_LIMPIEZA',
                criticalMomentInclude: [12951],
                mapper: orderMapper,
                extraConfigs: {
                    colors: OXXO_COLORS_STACKED_BAR
                },
                extras: {
                    groupNameFormat: 'description',
                    formula: 'count-number'
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'stackedBar',
                title: 'Satisfacción sobre la limpieza del baño',
                size: [2, 2],
                helpText: '¿Cómo calificarías la limpieza general de los sanitarios?',
                indicator: 'OXXO_BANIO_LIMPIEZA',
                criticalMomentInclude: [12951],
                mapper: (data: any) => {
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                    }))
                },
                extraConfigs: {
                    colors: OXXO_COLORS_STACKED_BAR,
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'verticalStackedBar',
                title: 'Satisfacción sobre la limpieza del baño',
                size: [4, 2],
                helpText: '¿Cómo calificarías la limpieza general de los sanitarios?',
                indicator: 'OXXO_BANIO_LIMPIEZA',
                criticalMomentInclude: [12951],
                mapper: (data: any) => {
                    return data
                },
                extras: {
                    formula: 'count-number',
                    "groupBy": "formattedMonth,numberAnswer",
                    "sort": "asc",
                    "periods": 6,
                    "sortBy": "groupName",
                },

                extraConfigs: {
                    id: 'OXXO_BANIO_LIMPIEZA',
                    colors: OXXO_COLORS_STACKED_BAR,
                    layout: 'vertical',
                    itemWidth: 200,
                    showXAxisLabel: true

                },
            }),

            {
                title: 'Satisfacción - Disponibilidad de suministros',
                type: 'label',
                size: [4, 1]
            },
            getLineDetailedRadar({
                mainIndicator: 'OXXO_BANIO_SUMINISTROS',
                mainIndicatorGral: 'satisfaction',
                radialIndicators: [],
                size: [4, 4],
                title: 'Satisfacción General',
                extraConfigs: {
                    backgroundColor: '#241d38',
                    theme: 'dark',
                    showRadialChart: false,
                    colors: [OXXO_DEFAULT_COLORS.VERDE, OXXO_DEFAULT_COLORS.AMARILLO, OXXO_DEFAULT_COLORS.ROJO, OXXO_DEFAULT_COLORS.AZUL],
                    decimals: 1,
                    symbol: ''
                },
                criticalMomentInclude: [12951],
                indicatorsNames: { 'OXXO_BANIO_SUMINISTROS': 'Satisfacción' },
                geoGrupedCondition: geoGrupedCondition
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Satisfaccion sobre disponibilidad de suministros',
                helpText: '¿Qué tan satisfecho estás con la disponibilidad de suministros (papel higiénico, jabón, toallas secantes etc.)?',
                size: [2, 2],
                indicator: 'OXXO_BANIO_SUMINISTROS',
                criticalMomentInclude: [12951],
                mapper: (data: any) => {
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                    }))
                },
                extraConfigs: {
                    colors: OXXO_COLORS_STACKED_BAR
                },
                extras: {
                    groupNameFormat: 'description',
                    formula: 'count-number'
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'stackedBar',
                title: 'Satisfaccion sobre disponibilidad de suministros',
                size: [2, 2],
                helpText: '¿Qué tan satisfecho estás con la disponibilidad de suministros (papel higiénico, jabón, toallas secantes etc.)?',
                indicator: 'OXXO_BANIO_SUMINISTROS',
                criticalMomentInclude: [12951],
                mapper: (data: any) => {
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                    }))
                },
                extraConfigs: {
                    colors: OXXO_COLORS_STACKED_BAR
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'verticalStackedBar',
                title: 'Satisfacción sobre la limpieza del baño',
                size: [4, 2],
                helpText: '¿Cómo calificarías la limpieza general de los sanitarios?',
                indicator: 'OXXO_BANIO_SUMINISTROS',
                criticalMomentInclude: [12951],
                mapper: (data: any) => {
                    return data
                },
                extras: {
                    formula: 'count-number',
                    "groupBy": "formattedMonth,numberAnswer",
                    "sort": "asc",
                    "periods": 6,
                    "sortBy": "groupName",
                },

                extraConfigs: {
                    id: 'OXXO_BANIO_SUMINISTROS',
                    colors: OXXO_COLORS_STACKED_BAR,
                    layout: 'vertical',
                    itemWidth: 200,
                    showXAxisLabel: true

                },
            }),
            {
                title: 'Satisfacción - Mantenimiento del Baño',
                type: 'label',
                size: [4, 1]
            },
            getLineDetailedRadar({
                mainIndicator: 'OXXO_BANIO_MANTENIMIENTO',
                mainIndicatorGral: 'satisfaction',
                radialIndicators: [],
                size: [4, 4],
                title: 'Satisfacción General',
                extraConfigs: {
                    backgroundColor: '#241d38',
                    theme: 'dark',
                    showRadialChart: false,
                    colors: [OXXO_DEFAULT_COLORS.VERDE, OXXO_DEFAULT_COLORS.AMARILLO, OXXO_DEFAULT_COLORS.ROJO, OXXO_DEFAULT_COLORS.AZUL],
                    decimals: 1,
                    symbol: ''
                },
                criticalMomentInclude: [12951],
                indicatorsNames: { 'OXXO_BANIO_MANTENIMIENTO': 'Satisfacción' },
                geoGrupedCondition: geoGrupedCondition
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Satisfaccion sobre el mantenimiento del Baño',
                helpText: '¿Qué tan satisfecho estás sobre las condiciones y el nivel de mantenimiento de los accesorios? (inodoro, el lavamanos, el espejo  y demás elementos similares)',
                size: [2, 2],
                indicator: 'OXXO_BANIO_MANTENIMIENTO',
                criticalMomentInclude: [12951],
                mapper: (data: any) => {
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                    }))
                },
                extraConfigs: {
                    colors: OXXO_COLORS_STACKED_BAR
                },
                extras: {
                    groupNameFormat: 'description',
                    formula: 'count-number'
                },
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'stackedBar',
                title: 'Satisfaccion sobre el mantenimiento del Baño',
                size: [2, 2],
                helpText: '¿Qué tan satisfecho estás sobre las condiciones y el nivel de mantenimiento de los accesorios? (inodoro, el lavamanos, el espejo  y demás elementos similares)',
                indicator: 'OXXO_BANIO_MANTENIMIENTO',
                criticalMomentInclude: [12951],
                mapper: (data: any) => {
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                    }))
                },
                extraConfigs: {
                    colors: OXXO_COLORS_STACKED_BAR
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'verticalStackedBar',
                title: 'Satisfacción sobre la limpieza del baño',
                size: [4, 2],
                helpText: '¿Cómo calificarías la limpieza general de los sanitarios?',
                indicator: 'OXXO_BANIO_MANTENIMIENTO',
                criticalMomentInclude: [12951],
                mapper: (data: any) => {
                    return data
                },
                extras: {
                    formula: 'count-number',
                    "groupBy": "formattedMonth,numberAnswer",
                    "sort": "asc",
                    "periods": 6,
                    "sortBy": "groupName",
                },

                extraConfigs: {
                    id: 'OXXO_BANIO_MANTENIMIENTO',
                    colors: OXXO_COLORS_STACKED_BAR,
                    layout: 'vertical',
                    itemWidth: 200,
                    showXAxisLabel: true

                },
            }),
            {
                title: 'Sentimientos',
                type: 'label',
                size: [4, 1],
            },
            /*getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                size: [2, 3],
                indicator: 'OXXO_BANIO_COMENTARIOS',
                criticalMomentInclude: [12951],
                extraConfigs: {
                    showGeoLocation: true
                }
                
            }),
            */
            getCommonWidget({
                   commonWidgets: commonWidgets,
                   name: 'tagsAnalysis',
                   title: 'Análisis de comentarios negativos',
                   size: [4, 4],
                   key: 'tags-analysis-negative-banios',
                   criticalMomentInclude: [12951],
                   extraConfigs: {
                     colors: OXXO_DEFAULT_SCALE_3_COLORS,
                     showGeoLocation: true,
                     rankByScore: true,
                     commentType: 'negative',
                     commentsLimit: 5
                   },
                   extras: {
                     numberAnswerTo: 0
                   }
                 }),
            getCommonWidget({
                   commonWidgets: commonWidgets,
                   name: 'tagsAnalysis',
                   title: 'Análisis de comentarios positivos',
                   size: [4, 4],
                   key: 'tags-analysis-positive-banios',
                   criticalMomentInclude: [12951],
                   extraConfigs: {
                     colors: OXXO_DEFAULT_SCALE_3_COLORS,
                     showGeoLocation: true,
                     rankByScore: true,
                     commentType: 'positive',
                     commentsLimit: 5
                   },
                   extras: {
                     numberAnswerFrom: 1
                   }
                 }),
            /*getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'wordCount',
                title: 'Nube de Palabras / Frecuencia en comentarios',
                size: [2, 3],
                criticalMomentInclude: [12951],
            }),
            */
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                title: "Analisis de Sentimientos",
                indicator: 'SENTIMENT',
                position: [0, 15],
                size: [4, 3],
                extraConfigs: {
                    colors: OXXO_DEFAULT_SCALE_3_COLORS
                }
            }),

        ]
    },
} as DasboardConfig
